import(/* webpackMode: "eager" */ "/Users/zrzz/Coding/openpaper/client/src/app/(main)/(protected)/papers/page.tsx");
